import { render, staticRenderFns } from "./NuevosIngresos.vue?vue&type=template&id=7e4a720a"
import script from "./NuevosIngresos.vue?vue&type=script&lang=js"
export * from "./NuevosIngresos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports